import type { UserAssetRecord } from "@apis/http/api";

export const resolvePostVideoAssetId = (record: UserAssetRecord): number | null => {
  const id = record.id;
  if (typeof id === "number" && Number.isFinite(id) && id > 0) {
    return id;
  }
  return null;
};
